<template>
  <div id="contenedor-validador-contrato-estimaciones">
    <div class="mb-2">
      <h4>
        {{ getContrato && getContrato.numero }}
      </h4>
      <div>
        <span class="font-weight-medium">Contratista: </span>
  {{ getContrato && getContrato.contratista && getContrato.contratista.nombreRazonSocial }}
      </div>
    </div>
    <v-divider class="my-2"></v-divider>
    <v-row no-gutters class="font-weight-black">
      <v-col cols="4">Fechas</v-col>
      <v-col cols="3" class="text-center">F. Inicio</v-col>
      <v-col cols="3" class="text-center">F. Término</v-col>
    </v-row>
    <v-row no-gutters :class="{
        'text-decoration-line-through text--disabled': isContratoStruck
      }">
      <v-col cols="4">Según Contrato</v-col>
      <v-col cols="3" class="text-center">
        {{ formatDateSafe(contratoInicio) }}
      </v-col>
      <v-col cols="3" class="text-center">
        {{ formatDateSafe(contratoTermino) }}
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>
    <v-row no-gutters :class="{
        'text-decoration-line-through text--disabled': isConvenioStruck
      }">
      <v-col cols="4">Según Convenios</v-col>
      <v-col cols="3" class="text-center">
        {{ formatDateSafe(convenioInicio) }}
      </v-col>
      <v-col cols="3" class="text-center">
        {{ formatDateSafe(convenioTermino) }}
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="4">Según Programa de Obras</v-col>
      <v-col cols="3" class="text-center">
        {{ formatDateSafe(programaInicio) }}
      </v-col>
      <v-col cols="3" class="text-center">
        {{ formatDateSafe(programaTermino) }}
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>
    <v-divider class="my-2"></v-divider>
    <v-row no-gutters class="font-weight-black">
      <v-col cols="12">Montos</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="4">Según Contrato y Convenios</v-col>
      <v-col cols="4" class="text-right mb-1">
        <v-chip small>
          {{ getImporteContratadoModificado | currency }}
        </v-chip>
      </v-col>
      <v-col cols="4">
        <span class="text-decoration-underline ml-1">
          Monto modificado
        </span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="4">Según Programa de Obra</v-col>
      <v-col cols="4" class="text-right">
        <v-chip
          class="mb-1"
          small
          :color="getMontoProgramaCoincideContratadoModificado ? 'success' : 'warning'">
          <v-icon left small>
            {{ getMontoProgramaCoincideContratadoModificado ? 'mdi-check-circle' : 'mdi-alert' }}
          </v-icon>
          {{ getMontoDelPrograma | currency }}
        </v-chip>
      </v-col>
      <v-col cols="4" class="ml-1">
        <template
          v-if="!getMontoProgramaCoincideContratadoModificado">
          <span class="text-decoration-underline">
            No coinciden
          </span>
        </template>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="4">Según Catálogo de Conceptos</v-col>
      <v-col cols="4" class="text-right">
        <v-chip
          class="mb-1"
          small
          :color="getMontoCatalogoConcideContratadoModificado ? 'success' : 'warning'">
          <v-icon left small>
            {{ getMontoCatalogoConcideContratadoModificado ? 'mdi-check-circle' : 'mdi-alert' }}
          </v-icon>
          {{ getImporteTotalContratoCatalogo | currency }}
        </v-chip>
      </v-col>
      <v-col cols="4">
        <template
          v-if="!getMontoCatalogoConcideContratadoModificado">
          <span class="text-decoration-underline">
            No coinciden
          </span>
        </template>
      </v-col>
    </v-row>
    <v-divider class="my-2"></v-divider>
    <v-row no-gutters class="font-weight-black">
      <v-col cols="12">
        Deducciones a Aplicar
      </v-col>
    </v-row>
    <v-row
      no-gutters
      v-for="deduccion in contratoDeducciones"
      :key="deduccion.id">
      <v-col cols="12">
        {{ deduccion.deduccion.nombre }}
      </v-col>
    </v-row>
    <v-divider class="my-2"></v-divider>
    <v-row no-gutters class="font-weight-black">
      <v-col cols="12">
        Penas Convencionales
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="5">
        Porcentaje de Retención (Si aplica)
      </v-col>
      <v-col cols="7" class="font-weight-medium">
  {{ getContrato && getContrato.porcentajeRetencion }}% Por dias de atraso
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="5">
        Porcentaje de Sanción (Si aplica)
      </v-col>
      <v-col cols="7" class="font-weight-medium">
  {{ getContrato && getContrato.porcentajeSancion }}% Diaria
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CONTRATO_ANTICIPOS from '@/graphql/querys/administracion/contratos/contrato/anticipos.gql';
import CONTRATO_CONVENIOS_MODIFICATORIOS from '@/graphql/querys/administracion/contratos/contrato/convenios.gql';
import CONTRATOS_DEDUCCIONES from '@/graphql/querys/administracion/contratos/deducciones/contratoDeducciones.gql';
import CONTRATO_CATALOGO_IMPORTE_TOTAL from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoImporteTotal.gql';
import CONTRATO_PROGRAMAS_OBRA from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';
import CONTRATO_ESTIMACIONES_VALIDACIONES from '@/graphql/querys/administracion/contratos/contartoEstimacionesValidaciones.gql';

export default {
  name: 'ValidadorContratoEstimaciones',
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      idContratoProgramaSeleccionado: null,
    };
  },
  apollo: {
    contrato: {
      query: CONTRATO_ESTIMACIONES_VALIDACIONES,
      variables() {
        return {
          id: this.idContrato,
        };
      },
    },
    contratoAnticipos: {
      query: CONTRATO_ANTICIPOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoConveniosModificatorios: {
      query: CONTRATO_CONVENIOS_MODIFICATORIOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoDeducciones: {
      query: CONTRATOS_DEDUCCIONES,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoCatalogoImporteTotal: {
      query: CONTRATO_CATALOGO_IMPORTE_TOTAL,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRA,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};

      return this.contrato;
    },
    // Helpers to shorten template expressions
    contratoInicio() {
      return this.getContrato && this.getContrato.fechaInicio;
    },
    contratoTermino() {
      return this.getContrato && this.getContrato.fechaTermino;
    },
    convenioInicio() {
      return (
        this.getContrato
        && this.getContrato.modificado
        && this.getContrato.modificado.fechaInicio
      );
    },
    convenioTermino() {
      return (
        this.getContrato
        && this.getContrato.modificado
        && this.getContrato.modificado.fechaTermino
      );
    },
    programaInicio() {
      return (
        this.getFechaInicioTerminoPrograma
        && this.getFechaInicioTerminoPrograma.inicio
      );
    },
    programaTermino() {
      return (
        this.getFechaInicioTerminoPrograma
        && this.getFechaInicioTerminoPrograma.termino
      );
    },
    isContratoStruck() {
      return (
        this.getContrato
        && this.getContrato.modificado
        && this.getContrato.modificado.fechaInicio
      ) !== null;
    },
    isConvenioStruck() {
      return (
        this.getContrato
        && this.getContrato.modificado
        && this.getContrato.modificado.fechaInicio
      ) === null;
    },
    getImporteContratadoModificado() {
      return (
        this.getContrato.importe
      + this.getContrato?.modificado?.importe);
    },
    getImporteTotalContratoCatalogo() {
      if (!this.contratoCatalogoImporteTotal) return 0;

      return this.contratoCatalogoImporteTotal;
    },
    getProgramaSeleccionado() {
      if (!this.contratoProgramasObra) return [];
      if (this.idContratoProgramaSeleccionado) {
        return this.contratoProgramasObra
          .find(({ id }) => id === this.idContratoProgramaSeleccionado);
      }

      return this.contratoProgramasObra.filter(({ esUltimo }) => esUltimo === true)[0];
    },
    getPrograma() {
      if (!this.getProgramaSeleccionado.programa) return [];

      return this.getProgramaSeleccionado.programa
        .slice()
        .sort((a, b) => new Date(`${a.fechaTermino}T00:00:00Z`)
        - new Date(`${b.fechaTermino}T00:00:00Z`));
    },
    getFechaInicioTerminoPrograma() {
      if (!this.getProgramaSeleccionado.programa) {
        return {
          inicio: null,
          termino: null,
        };
      }

      const { fechaInicio } = this.getPrograma[0];
      const { fechaTermino } = this.getPrograma[this.getPrograma.length - 1];

      return {
        inicio: fechaInicio,
        termino: fechaTermino,
      };
    },
    getMontoDelPrograma() {
      if (!this.getProgramaSeleccionado.programa) return 0;

      return this.$ObjSumar(this.getPrograma, 'monto');
    },
    getMontoProgramaCoincideContratadoModificado() {
      return (
        this.getImporteContratadoModificado === this.getMontoDelPrograma
      );
    },
    getMontoCatalogoConcideContratadoModificado() {
      return (this.getImporteContratadoModificado === this.getImporteTotalContratoCatalogo);
    },
  },
  methods: {
    formatDateSafe(dateStr) {
      if (!dateStr) return '';
      const d = new Date(`${dateStr}T00:00:00Z`);
      if (Number.isNaN(d.getTime())) return '';
      try {
        return d.toLocaleDateString();
      } catch (e) {
        return '';
      }
    },
  },
};
</script>

<style lang="scss">

</style>
